import React, { Component } from 'react';
import Itempagination from './itempagination.jsx';
import Recordloading from './recordloading.jsx';
import NameDisplay from './namedisplay.jsx';

class SortElements extends Component {

  render() {
      let currentOrderBy = this.props.currentOrderBy || '' ;
      let sortName = this.props.name;
      return (
        <div className="sort-element">
          <span> {sortName.fa} </span>
          <div className="chevrons-col">
            <span 
            className={"glyphicon glyphicon-chevron-up" + ( ( currentOrderBy === ''+sortName.en ) ? ' focused-sort' : '' ) } 
            onClick= { () => { this.props.sortFunc(''+sortName.en)} } 
            />
            <span 
            className={"glyphicon glyphicon-chevron-down" + ( ( currentOrderBy === '-'+sortName.en ) ? ' focused-sort' : '' ) }
            onClick= { () => { this.props.sortFunc('-'+sortName.en)} } 
            />
          </div>
        </div>
      );
  }
}



export class Detailedreport extends Component{
  render () {
    const records = this.props.report.page_records;
    let mappedRecords = '';
    let perPage = Number(this.props.report.paginationConfig.meta.per_page);
    let pageNumber = Number(this.props.report.paginationConfig.meta.page)
    if(records.length && records.length>0 ){
      mappedRecords = records.map((record,index) => (
        <tr key={index}>
          <td >{ ((pageNumber - 1 ) * perPage   + Number(index) + 1)+''}</td>
          <td className="justified-title" > 
            <NameDisplay name={record.name} truncNum={50} />
            <span className="label label-default project-label" style={{backgroundColor:record.project.color}} > {record.project.name.trunc(25)} </span>
          </td>
          <td > 
            <NameDisplay name={record.user.name} truncNum={35} />
          </td>
          <td > {record.duration} </td>
          <td className="time-day-container" > 
            <span className="time-col pull-right" >
              { record.time } 
            </span>
            <span className="day-col" >
              { record.day }
            </span>
            </td>
        </tr>
      ));
    }
  
    if( mappedRecords === ''){
      return (
        <div></div>
      )
    }
    else if( this.props.app.loading > 0 ){
      return <Recordloading />
    }
    else {
      let currentOrderBy= this.props.report.paginationConfig.query.order_by || '';
      return(
        <div className="container-fluid">
          <div className="row">
            <table className="table detailed-table">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>
                          <SortElements 
                           name={{en:"name",fa:'عنوان'}} 
                           sortFunc={this.props.sortDetailedList}
                           currentOrderBy={currentOrderBy}
                          />
                        </th>
                        <th>کاربر </th>
                        <th >
                          <SortElements 
                            name={{en:"duration",fa:'مدت'}} 
                            sortFunc={this.props.sortDetailedList}
                            currentOrderBy={currentOrderBy}
                          />                        
                        </th>
                        <th className="time-day-container" >
                          <SortElements 
                            name={{en:"start",fa:'زمان'}} 
                            sortFunc={this.props.sortDetailedList} 
                            currentOrderBy={currentOrderBy}                          
                          />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {mappedRecords}
                </tbody>
            </table>
          </div>
          <Itempagination mainFunc={this.props.getRecords} {...this.props.report.paginationConfig} />
        </div>
      )
    }
  
  }
}
